import { render, staticRenderFns } from "./palletEdit.vue?vue&type=template&id=3d801657&scoped=true"
import script from "./palletEdit.vue?vue&type=script&lang=js"
export * from "./palletEdit.vue?vue&type=script&lang=js"
import style0 from "./palletEdit.vue?vue&type=style&index=0&id=3d801657&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d801657",
  null
  
)

export default component.exports